import ReactDOM from "react-dom/client";
import App from "./app";
import "@core/styles/global.scss";
import { Provider } from "react-redux";
import store from "@app/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);
